import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faSearch,
  faAngleLeft,
  faAngleRight,
  faFilter,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faArrowUp);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faSearch);
library.add(faAngleLeft);
library.add(faAngleRight);
library.add(faFilter);
library.add(faSort);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

import "@/styles/index.scss";

import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "UA-118340427-3",
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
